var map = {
	"./AI-Chat-24px.svg": 69902,
	"./AIChat.png": 84252,
	"./CarInsuranceIcon.svg": 30651,
	"./ChatMgButton-trimmed.png": 20407,
	"./ChatMgButton.png": 9842,
	"./CheckIcon.png": 54925,
	"./DiscountUnderline.png": 29961,
	"./EnableWhatapp.png": 59674,
	"./ExternalLink.png": 32089,
	"./Frame.png": 71405,
	"./Gotham-Book.ttf": 7220,
	"./Gotham-Medium.ttf": 14773,
	"./IconCheck.svg": 28987,
	"./InsuranceTypesContents.png": 14509,
	"./L-Arrow-24px.svg": 85813,
	"./LinkIcon.svg": 56453,
	"./Menu.png": 28449,
	"./Personalisation.png": 59709,
	"./SpendingAnalysisGuide.png": 16532,
	"./SpendingAnalysisGuideSections.png": 44316,
	"./SpendingAnalysisImage.png": 167,
	"./SwitchAvatars.png": 33364,
	"./VouchersEmptyState.png": 75555,
	"./Wallet-24px.svg": 82180,
	"./Whatsapp.webp": 10715,
	"./WhatsappPromo.png": 69449,
	"./accountTypes/credit-card.png": 20095,
	"./accountTypes/current-account.png": 81324,
	"./accountTypes/insurance.png": 10881,
	"./accountTypes/investments.png": 90151,
	"./accountTypes/loans.png": 31892,
	"./accountTypes/mortgage.png": 23391,
	"./accountTypes/pension.png": 23055,
	"./accountTypes/savings-account.png": 46882,
	"./addCurrentAccountBenefits.png": 6963,
	"./ai.png": 8178,
	"./aisummary-noborder.png": 10024,
	"./aisummary.png": 77828,
	"./arrow-left.png": 18123,
	"./arrow-left.svg": 48609,
	"./arrow-right.png": 50100,
	"./available_vouchers.png": 16917,
	"./basket.svg": 81944,
	"./bell.svg": 95853,
	"./benefits.png": 34064,
	"./bg/BuyWithConfidence.png": 44708,
	"./bg/BuyWithConfidenceZoomed.png": 78082,
	"./bg/Currys.png": 40846,
	"./bg/TrackSpend.png": 70365,
	"./bg/VouchersLinkAccounts.png": 35435,
	"./bg/bg.png": 27075,
	"./bg/boosted.png": 24274,
	"./bg/hero-blurred.png": 7661,
	"./bg/hero.png": 37386,
	"./bg/howItWorksVouchers.png": 30926,
	"./bg/marbles.png": 52954,
	"./bg/puzzle.png": 90030,
	"./bg/vault.png": 6968,
	"./budget-plan-icon.svg": 59887,
	"./bullet-bell.png": 43416,
	"./bullet-doc.png": 11657,
	"./bullet-lock.png": 82454,
	"./bullet-question.png": 68927,
	"./bullet-tick.png": 23724,
	"./cache.png": 23168,
	"./calendar.png": 66226,
	"./categories/bakery-coffee.png": 86088,
	"./categories/blurred/bakery-coffee.png": 67057,
	"./categories/blurred/entertainment.png": 3342,
	"./categories/blurred/family.png": 64342,
	"./categories/blurred/fashion.png": 70388,
	"./categories/blurred/gifts.png": 15041,
	"./categories/blurred/home-garden.png": 19761,
	"./categories/blurred/hotels.png": 33407,
	"./categories/blurred/leisure.png": 85245,
	"./categories/entertainment.png": 29023,
	"./categories/family.png": 85705,
	"./categories/fashion.png": 64373,
	"./categories/gifts.png": 96240,
	"./categories/home-garden.png": 20976,
	"./categories/hotels.png": 74052,
	"./categories/leisure.png": 47128,
	"./check-tick.svg": 66460,
	"./chevron-down.png": 99174,
	"./clearx.png": 32101,
	"./clock.png": 90248,
	"./close-24px.svg": 44221,
	"./close.png": 57190,
	"./coins.png": 28792,
	"./coins2.png": 11864,
	"./credit-card.png": 97096,
	"./doc-categories/banking.png": 31208,
	"./doc-categories/family.png": 76856,
	"./doc-categories/health.png": 51350,
	"./doc-categories/home.png": 90265,
	"./doc-categories/important.png": 59356,
	"./doc-categories/investments.png": 72604,
	"./doc-categories/other.png": 73788,
	"./doc-categories/personal.png": 60708,
	"./doc-categories/pets.png": 59286,
	"./doc-categories/subscriptions.png": 20484,
	"./doc-categories/tax.png": 8733,
	"./doc-categories/travel.png": 47616,
	"./doc-categories/vehicle.png": 35974,
	"./doc-categories/work.png": 12843,
	"./doc.png": 25392,
	"./document.png": 8563,
	"./dot.svg": 34691,
	"./edit.png": 46700,
	"./email.png": 85738,
	"./emptyRadio.png": 11456,
	"./excluded-switch.png": 13629,
	"./excluded.svg": 96392,
	"./family.png": 60276,
	"./figureofeight.png": 14514,
	"./filledRadio.png": 15759,
	"./filledbell.png": 83699,
	"./financialFitness.png": 69859,
	"./financialFitnessIcon.png": 7392,
	"./go.png": 85694,
	"./green-dot.png": 54645,
	"./headerbolt1.png": 29597,
	"./headerbolt2.png": 88358,
	"./heart.png": 70150,
	"./i.png": 9315,
	"./icon-calendar.svg": 54888,
	"./icon-chat.svg": 25432,
	"./icon-document.svg": 47353,
	"./icons/coins-stacked.png": 18903,
	"./icons/coins-swap-green.png": 99565,
	"./icons/coins-swap.png": 83783,
	"./icons/credit-card-plus.png": 26002,
	"./icons/face-smile-purple.svg": 61954,
	"./icons/face-smile.png": 36085,
	"./icons/shopping-bag.png": 32712,
	"./inStore.png": 34370,
	"./info-16px.svg": 20002,
	"./info.png": 16768,
	"./infooutline.png": 77064,
	"./light-arrow-right.png": 45935,
	"./lightning-bolt.png": 75022,
	"./lightning.svg": 48848,
	"./linkto.png": 14439,
	"./lock.svg": 76807,
	"./logo.png": 33153,
	"./logos/MGLogo.svg": 24572,
	"./logos/TrueLayer.svg": 80260,
	"./logos/Vouchers.png": 40174,
	"./logos/amex.svg": 66032,
	"./logos/bankofscotland.svg": 51876,
	"./logos/barclays.svg": 13826,
	"./logos/capitalone.svg": 78037,
	"./logos/firstdirect.svg": 8894,
	"./logos/halifax.svg": 79394,
	"./logos/hsbc.svg": 39115,
	"./logos/lloyds.svg": 28606,
	"./logos/mbna.svg": 7015,
	"./logos/metro.svg": 31752,
	"./logos/monese.svg": 48218,
	"./logos/monzo.svg": 39384,
	"./logos/ms.svg": 4053,
	"./logos/nationwide.svg": 72429,
	"./logos/natwest.svg": 4967,
	"./logos/paragon.svg": 99209,
	"./logos/revolut.svg": 83558,
	"./logos/santander.svg": 8003,
	"./logos/starling.svg": 59817,
	"./logos/temp_charliehr.png": 22936,
	"./logos/temp_charliehr.svg": 80498,
	"./logos/temp_peoplepension.png": 62601,
	"./logos/temp_peoplepension.svg": 18079,
	"./logos/temp_shopst.png": 43851,
	"./logos/temp_shopst.svg": 8059,
	"./logos/temp_unum.png": 77085,
	"./logos/temp_unum.svg": 95273,
	"./logos/temp_vitality.svg": 17352,
	"./logos/tesco.svg": 90197,
	"./logos/tide.svg": 24761,
	"./logos/tsb.svg": 21620,
	"./logos/virginmoney.svg": 96158,
	"./maintenance.png": 95519,
	"./maps.png": 38445,
	"./menu-burger-24px.svg": 20826,
	"./menu/Activity.svg": 4097,
	"./menu/ActivityOn.svg": 37306,
	"./menu/Guide.svg": 3970,
	"./menu/GuideOn.svg": 36589,
	"./menu/Home.svg": 99499,
	"./menu/HomeOn.svg": 69596,
	"./menu/Money.svg": 36394,
	"./menu/MoneyOn.svg": 49077,
	"./menu/You.svg": 55051,
	"./menu/YouOn.svg": 12156,
	"./menu/vertical-dots.svg": 64445,
	"./mg.png": 28408,
	"./mgm-avatar-blue.png": 83060,
	"./mgm-avatar.png": 76021,
	"./moneyHelper.png": 30942,
	"./mymgm-hero.png": 57016,
	"./notificationbell.png": 77278,
	"./offlineAccount.png": 94618,
	"./online.png": 54289,
	"./open-banking-bg.png": 61641,
	"./open-banking-black.png": 58007,
	"./open-banking.png": 35653,
	"./openbankingmarker.png": 26474,
	"./orange-dot.png": 46404,
	"./payment-methods.png": 92177,
	"./plus-inverted.png": 58840,
	"./plus.png": 80528,
	"./points.png": 33741,
	"./policies.png": 43354,
	"./prod1.png": 43218,
	"./prod2.png": 74185,
	"./prod3.png": 96064,
	"./prod4.png": 47391,
	"./products/buildings.png": 31670,
	"./products/buildingscontents.png": 96864,
	"./products/contents.png": 33291,
	"./products/criticalillness.png": 28656,
	"./products/debts.png": 12883,
	"./products/incomeprotection.png": 97225,
	"./products/investments.png": 71695,
	"./products/life.png": 76963,
	"./products/lifecriticalillness.png": 59066,
	"./products/medical.png": 91784,
	"./products/mortgage.png": 24215,
	"./products/pensions.png": 77500,
	"./products/pet.png": 10086,
	"./products/phone.png": 57949,
	"./products/travel.png": 5041,
	"./products/vehicle.png": 69137,
	"./quiz/cross.png": 37770,
	"./quiz/flame.png": 66179,
	"./quiz/peel-large.svg": 15416,
	"./quiz/quiz-default-bg.png": 14047,
	"./quiz/snow-flake.png": 65973,
	"./quiz/tick.png": 50343,
	"./recurring.png": 68343,
	"./refer-hero.png": 33015,
	"./refresh-cw.svg": 80362,
	"./reminders.png": 99795,
	"./round1.png": 80117,
	"./round2.png": 12766,
	"./round3.png": 31079,
	"./search.png": 91060,
	"./settingscog.png": 21610,
	"./spendCategories/Bills.png": 77265,
	"./spendCategories/Bills.svg": 41877,
	"./spendCategories/Clothes.png": 27879,
	"./spendCategories/Clothes.svg": 16483,
	"./spendCategories/Coffee.png": 91067,
	"./spendCategories/Coffee.svg": 55901,
	"./spendCategories/CreditCards.png": 84163,
	"./spendCategories/CreditCards.svg": 61363,
	"./spendCategories/Dark_excludedFromAnalysisIcon.png": 13443,
	"./spendCategories/Dark_excludedFromAnalysisIcon.svg": 45443,
	"./spendCategories/Debts.png": 50593,
	"./spendCategories/Debts.svg": 14205,
	"./spendCategories/Drinks.png": 74286,
	"./spendCategories/Drinks.svg": 25972,
	"./spendCategories/EatingOut.png": 97345,
	"./spendCategories/EatingOut.svg": 76409,
	"./spendCategories/Education.png": 14685,
	"./spendCategories/Education.svg": 38177,
	"./spendCategories/Entertainment.png": 69637,
	"./spendCategories/Entertainment.svg": 84025,
	"./spendCategories/Family.png": 21935,
	"./spendCategories/Family.svg": 26993,
	"./spendCategories/Fitness.png": 5455,
	"./spendCategories/Fitness.svg": 87539,
	"./spendCategories/Gambling.png": 97190,
	"./spendCategories/Gambling.svg": 53152,
	"./spendCategories/Gifts.png": 66834,
	"./spendCategories/Gifts.svg": 4182,
	"./spendCategories/Groceries.png": 34570,
	"./spendCategories/Groceries.svg": 50194,
	"./spendCategories/Holiday.png": 67779,
	"./spendCategories/Holiday.svg": 61683,
	"./spendCategories/Home&Garden.png": 90573,
	"./spendCategories/Home&Garden.svg": 66133,
	"./spendCategories/Home.png": 52442,
	"./spendCategories/Home.svg": 43968,
	"./spendCategories/Insurance.png": 56219,
	"./spendCategories/Insurance.svg": 48687,
	"./spendCategories/InternalTransfers.png": 438,
	"./spendCategories/InternalTransfers.svg": 35466,
	"./spendCategories/InternalTransfersIcon.png": 13801,
	"./spendCategories/InternalTransfersIcon.svg": 32137,
	"./spendCategories/Investments.png": 60729,
	"./spendCategories/Investments.svg": 72625,
	"./spendCategories/LargePurchases.png": 23012,
	"./spendCategories/LargePurchases.svg": 66126,
	"./spendCategories/Medical.png": 59658,
	"./spendCategories/Medical.svg": 42974,
	"./spendCategories/Other.png": 33289,
	"./spendCategories/Other.svg": 67933,
	"./spendCategories/Pets.png": 92189,
	"./spendCategories/Pets.svg": 73411,
	"./spendCategories/Resources.png": 75136,
	"./spendCategories/Resources.svg": 58596,
	"./spendCategories/Salary.png": 11321,
	"./spendCategories/Salary.svg": 89531,
	"./spendCategories/Savings.png": 56242,
	"./spendCategories/Savings.svg": 41338,
	"./spendCategories/Selfcare.png": 82630,
	"./spendCategories/Selfcare.svg": 19908,
	"./spendCategories/Shopping.png": 69315,
	"./spendCategories/Shopping.svg": 55617,
	"./spendCategories/Socialising.png": 77452,
	"./spendCategories/Socialising.svg": 38628,
	"./spendCategories/Takeaways.png": 82865,
	"./spendCategories/Takeaways.svg": 73977,
	"./spendCategories/Transport.png": 74256,
	"./spendCategories/Transport.svg": 64360,
	"./spendCategories/Travel.png": 92899,
	"./spendCategories/Travel.svg": 22501,
	"./spendCategories/Uncategorized.png": 57069,
	"./spendCategories/Uncategorized.svg": 40225,
	"./spendCategories/Vehicle.png": 6479,
	"./spendCategories/Vehicle.svg": 1723,
	"./spending-analysis.png": 74257,
	"./spendingtreemap.png": 6332,
	"./spendingtreemap2.png": 43092,
	"./switch.png": 62380,
	"./tada.gif": 4559,
	"./thumbnails/badge.png": 90395,
	"./tip.png": 14737,
	"./transactions/benefits.png": 2888,
	"./transactions/benefits.svg": 73900,
	"./transactions/bills.png": 64672,
	"./transactions/bills.svg": 56782,
	"./transactions/charity.png": 62958,
	"./transactions/charity.svg": 65040,
	"./transactions/check tick.png": 99963,
	"./transactions/clothes.png": 30726,
	"./transactions/clothes.svg": 4640,
	"./transactions/clothing.png": 45664,
	"./transactions/clothing.svg": 42964,
	"./transactions/coffee.png": 30916,
	"./transactions/coffee.svg": 48484,
	"./transactions/coffees.png": 82037,
	"./transactions/coffees.svg": 3023,
	"./transactions/creditcards.png": 67894,
	"./transactions/creditcards.svg": 57068,
	"./transactions/dark_excludedfromanalysisicon.png": 58614,
	"./transactions/dark_excludedfromanalysisicon.svg": 61516,
	"./transactions/debts.png": 87600,
	"./transactions/debts.svg": 32718,
	"./transactions/drinks.png": 31413,
	"./transactions/drinks.svg": 99025,
	"./transactions/eatingout.png": 13104,
	"./transactions/eatingout.svg": 92030,
	"./transactions/education.png": 49768,
	"./transactions/education.svg": 74170,
	"./transactions/entertainment.png": 85852,
	"./transactions/entertainment.svg": 85714,
	"./transactions/essentials.png": 20495,
	"./transactions/essentials.svg": 37407,
	"./transactions/family.png": 73036,
	"./transactions/family.svg": 4472,
	"./transactions/fitness.png": 67106,
	"./transactions/fitness.svg": 93672,
	"./transactions/future.png": 3093,
	"./transactions/future.svg": 83845,
	"./transactions/gambling.png": 24937,
	"./transactions/gambling.svg": 60361,
	"./transactions/general.png": 72038,
	"./transactions/general.svg": 62464,
	"./transactions/gifts.png": 74283,
	"./transactions/gifts.svg": 42389,
	"./transactions/groceries.png": 16491,
	"./transactions/groceries.svg": 75757,
	"./transactions/health.png": 29130,
	"./transactions/health.svg": 71290,
	"./transactions/hobbies.png": 23354,
	"./transactions/hobbies.svg": 77368,
	"./transactions/holiday.png": 17286,
	"./transactions/holiday.svg": 30860,
	"./transactions/home&garden.png": 18468,
	"./transactions/home&garden.svg": 44186,
	"./transactions/home.png": 75341,
	"./transactions/home.svg": 39389,
	"./transactions/income.png": 74861,
	"./transactions/income.svg": 21337,
	"./transactions/insurance.png": 23426,
	"./transactions/insurance.svg": 83412,
	"./transactions/insurances.png": 71603,
	"./transactions/insurances.svg": 92639,
	"./transactions/insurnace.png": 94360,
	"./transactions/insurnace.svg": 11206,
	"./transactions/interest.png": 58286,
	"./transactions/interest.svg": 52990,
	"./transactions/internaltransfers.png": 31975,
	"./transactions/internaltransfers.svg": 86009,
	"./transactions/internaltransfersicon.png": 66708,
	"./transactions/internaltransfersicon.svg": 33990,
	"./transactions/investments.png": 3840,
	"./transactions/investments.svg": 70678,
	"./transactions/largepurchases.png": 33835,
	"./transactions/largepurchases.svg": 10459,
	"./transactions/lifestyle.png": 45959,
	"./transactions/lifestyle.svg": 26493,
	"./transactions/list.png": 80948,
	"./transactions/medical.png": 25923,
	"./transactions/medical.svg": 16381,
	"./transactions/mortgage.png": 33658,
	"./transactions/mortgage.svg": 73470,
	"./transactions/other.png": 26488,
	"./transactions/other.svg": 5574,
	"./transactions/pension in.png": 34287,
	"./transactions/pension in.svg": 23007,
	"./transactions/pension out.png": 6768,
	"./transactions/pension out.svg": 12330,
	"./transactions/pensionin.png": 43305,
	"./transactions/pensionin.svg": 93051,
	"./transactions/pensionout.png": 13982,
	"./transactions/pensionout.svg": 88126,
	"./transactions/pets.png": 43634,
	"./transactions/pets.svg": 76730,
	"./transactions/plus.png": 72792,
	"./transactions/rent.png": 70169,
	"./transactions/rent.svg": 65241,
	"./transactions/resources.png": 36129,
	"./transactions/resources.svg": 84839,
	"./transactions/salary.png": 29726,
	"./transactions/salary.svg": 63558,
	"./transactions/savings.png": 6519,
	"./transactions/savings.svg": 38693,
	"./transactions/selfcare.png": 44765,
	"./transactions/selfcare.svg": 25817,
	"./transactions/shopping.png": 23840,
	"./transactions/shopping.svg": 87820,
	"./transactions/socialising.png": 11561,
	"./transactions/socialising.svg": 77411,
	"./transactions/sports and fitness.png": 88386,
	"./transactions/sports and fitness.svg": 52638,
	"./transactions/sportsandfitness.png": 99044,
	"./transactions/sportsandfitness.svg": 77964,
	"./transactions/swipe.png": 32572,
	"./transactions/takeaways.png": 53448,
	"./transactions/takeaways.svg": 1822,
	"./transactions/tick.png": 35163,
	"./transactions/transfers.png": 22394,
	"./transactions/transfers.svg": 93272,
	"./transactions/transport.png": 32177,
	"./transactions/transport.svg": 40231,
	"./transactions/travel.png": 52908,
	"./transactions/travel.svg": 12668,
	"./transactions/uncategorised.png": 89969,
	"./transactions/uncategorised.svg": 25871,
	"./transactions/vehicle.png": 23706,
	"./transactions/vehicle.svg": 59544,
	"./transactions/withdrawals-1.png": 10716,
	"./transactions/withdrawals-1.svg": 91930,
	"./transactions/withdrawals.png": 54246,
	"./transactions/withdrawals.svg": 6452,
	"./transactions/work.png": 11575,
	"./transactions/work.svg": 57999,
	"./transparent.png": 90252,
	"./trashcan.png": 48384,
	"./user.png": 94441,
	"./verified.png": 75584,
	"./vouchers-in-store.svg": 65861,
	"./vouchers-online.svg": 62081,
	"./whatsapp.png": 60650,
	"./whatsapp.svg": 46144,
	"./whatsappicon.png": 2701
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;